<template>
    <v-row no-gutters>
        <v-col cols="12">
            <!-- hierarchical navigation -->
            <!-- <v-row justify="start" class="mt-2 mx-4">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">
                <p class="text-caption text-start">
                    <router-link :to="{ name: 'user-dashboard' }">Dashboard</router-link> &gt;
                    <router-link :to="{ name: 'user-account-list' }">Accounts</router-link>
                    <template v-if="account">
                    &gt;
                    <router-link :to="{ name: 'account-dashboard', params: { accountId: this.$route.params.accountId } }">{{ account.name }}</router-link>
                    </template>
                </p>
                </v-col>
            </v-row> -->
            <v-row justify="center" class="py-5 px-10 mt-8">
                <v-col cols="12" sm="10" md="8" lg="6" xl="4" class="pa-0">

                    <v-card>
                        <v-toolbar color="red darken-2 white--text" dark flat dense>
                        <!-- <v-app-bar-nav-icon></v-app-bar-nav-icon> -->
                        <v-toolbar-title>
                            Transfer domain
                        </v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <template v-if="!transferPrompt">
                                <p>You can transfer a domain between two accounts that you own.</p>
                                <p>Please contact customer support for assistance.</p>
                            </template>
                            <template v-if="transferPrompt">
                                <template v-if="account">
                                <p class="text-overline mb-0">Account name</p>
                                <p class="mb-0 pb-0">
                                    {{ account.name }}
                                </p>
                                </template>

                                <template v-if="domain">
                                <p class="text-overline mb-0 mt-4">Domain name</p>
                                <p class="mb-0 pb-0">
                                    {{ domain.name }}
                                </p>
                                </template>

                                <template v-if="domain && dnsRecordList">
                                <p class="text-overline mb-0 mt-4">DNS Records ({{ dnsRecordList.length }})</p>
                                <p class="mb-0 pb-0">
                                    <v-chip v-for="(item, idx) in dnsRecordList" :key="idx">{{ item.type }} {{ item.key }} {{ item.name }} {{ item.value }}</v-chip>
                                </p>
                                </template>

                                <p class="text-overline mb-0 mt-4">Confirmation</p>

                                <p>Tap on the button below to delete this domain, including all DNS records, and other related data.</p>

                                <v-alert type="warning" border="left" dense>
                                    <template #prepend>
                                        <font-awesome-icon fixed-width :icon="['fas', 'exclamation-triangle']" class="white--text text-body-1"/>
                                    </template>
                                    <span class="font-weight-bold ml-2">This action is not reversible.</span>
                                </v-alert>

                                <v-checkbox color="amber darken-2" v-model="transferConfirmation1" label="I want to delete my domain and all associated data" class="mt-0"></v-checkbox>
                                <v-checkbox color="amber darken-2" v-model="transferConfirmation2" label="I understand this will also unpublish all public and private DNS records for this domain hosted by LibertyDNS, and that my website or other network services may become unreachable" class="mt-0"></v-checkbox>
                                <v-checkbox color="amber darken-2" v-model="transferConfirmation3" label="I understand this action is not reversible, and that customer support will not be able to help me recover the data." class="mt-0"></v-checkbox>
                                <v-btn color="red" class="white--text" @click="deleteDomain" :disabled="!isDeleteDomainConfirmed">Delete Domain</v-btn>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<style scoped>

</style>

<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        account: null,
        domain: null,
        dnsRecordList: null,
        error: null,
        transferPrompt: false,
        transferConfirmation1: false,
        transferConfirmation2: false,
        transferConfirmation3: false,
    }),
    computed: {
        ...mapState({
            session: (state) => state.session,
            user: (state) => state.user,
        }),
        isPermitServiceAdmin() {
            return Array.isArray(this.user?.permit?.role) && this.user.permit.role.includes('service-admin');
        },
        isDeleteDomainConfirmed() {
            return this.transferConfirmation1 && this.transferConfirmation2 && this.transferConfirmation3;
        },
    },
    methods: {
        async loadAccount() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadAccount: true });
                const response = await this.$client.account(this.$route.params.accountId).self.get();
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.account = response;
                } else {
                    // TODO: redirect back to account list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load account', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadAccount: false });
            }
        },
        async loadDomain() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadDomain: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.get({ name: this.$route.params.domain });
                console.log(`account/dashboard.vue: response ${JSON.stringify(response)}`);
                if (response) {
                    this.domain = response;
                } else {
                    // TODO: redirect back to account list? show a not found message?
                }
            } catch (err) {
                console.error('failed to load account', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadDomain: false });
            }
        },
        async loadDnsRecordList() {
            try {
                this.error = false;
                this.$store.commit('loading', { loadDomainList: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.searchDnsRecord({ domain: this.$route.params.domain });
                if (Array.isArray(response.list)) {
                    this.dnsRecordList = response.list;
                }
            } catch (err) {
                console.error('failed to load account list', err);
                this.error = true;
            } finally {
                this.$store.commit('loading', { loadDomainList: false });
            }
        },
        async deleteDomain() {
            try {
                this.$store.commit('loading', { deleteDomain: true });
                const response = await this.$client.account(this.$route.params.accountId).domain.delete({ domain: this.$route.params.domain });
                if (response?.isDeleted) {
                    this.$bus.$emit('snackbar', { type: 'info', headline: 'Deleted domain', message: this.$route.params.domain });
                    this.$router.push({ name: 'user-dashboard' });
                } else {
                    this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to delete domain', message: this.$route.params.domain });
                }
            } catch (err) {
                console.error('failed to delete account', err);
                this.$bus.$emit('snackbar', { type: 'error', headline: 'Failed to delete domain', message: this.$route.params.domain });
            } finally {
                this.$store.commit('loading', { deleteDomain: false });
            }
        },
    },
    mounted() {
        this.loadAccount();
        this.loadDomain();
        this.loadDnsRecordList();
    },
};
</script>
